import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import organiserService from "../services/organiserService";

export const organiserListResponse = createAsyncThunk(
  "Organiser/list",
  async (data) => {
    const res = await organiserService.getOrganiser(data);
    return res?.data;
  }
);
export const createOrganiserResponse = createAsyncThunk(
  "Organiser/create",
  async (data) => {
    const res = await organiserService.createOrganiser(data);
    return res;
  }
);
export const deleteOrganiserAction = createAsyncThunk(
  "Organiser/delete",
  async (id) => {
    const res = await organiserService.deleteOrganiser(id);
    return res;
  }
);
export const deleteOrganiserItSelfAction = createAsyncThunk(
  "Organiser/deleteItSelf",
  async () => {
    const res = await organiserService.deleteOrganiserItSelf();
    return res;
  }
);

export const activeInactiveOrganiserAction = createAsyncThunk(
  "organiser/active-inactive",
  async (data) => {
    const res = await organiserService.activeInactiveOrganiser(data);
    return { res, params: data };
  }
);

export const resendInviteOrganiserResponse = createAsyncThunk(
  "organiser/resend-invite",
  async (data) => {
    const res = await organiserService.resendInviteOrganiser(data);
    return { res, params: data };
  }
);

export const setOrganiserPasswordAction = createAsyncThunk(
  "organiser/set-password",
  async (data) => {
    const res = await organiserService.setOrganiserPassword(data);

    return res;
  }
);

export const pastEventOfOrganiserAction = createAsyncThunk(
  "organiser/past-event",
  async (id) => {
    let res;
    if (id) {
      res = await organiserService.listOfPastEventByOrganiser(id);
    } else {
      res = await organiserService.listOfPastEventByOrganiser();
    }

    return res.data.map((item) => {
      const ticketPrices = Array.isArray(item?.tickets)
        ? item?.tickets?.map((ticket) => ticket.ticketprice)
        : [0];
      const sumTotalTickets = Array.isArray(item?.tickets)
        ? item?.tickets?.reduce((acc, ticket) => acc + ticket.totaltickets, 0)
        : 0;

      const sumTicketssold = Array.isArray(item?.tickets)
        ? item?.tickets?.reduce((acc, ticket) => acc + ticket.ticketssold, 0)
        : 0;
      return {
        _id: item._id,
        image: item?.image ? item?.image : "",
        category: item.category,
        title: item.title,
        location: item.location,
        startdatetime: item.startdatetime,
        enddatetime: item.enddatetime,
        artist: item.artistsDetails.map((artist) => ({
          id: artist._id,
          artistimage: artist?.image ? artist?.image : "",
          artistname: artist.name,
        })),
        eventstatus: item.eventstatus,
        // isdelivery: item.isdelivery,
        // ticketId: item?.ticketid ? item?.ticketid : "-",
        ticketssold: sumTicketssold,
        totaltickets: sumTotalTickets,
        bookingtiming: item.orderstatustimestamp,
        ticketPrice: item?.ticketprice
          ? item?.ticketprice
          : `${Math.min(...ticketPrices)} - ${Math.max(...ticketPrices)}`,
        viewTicker: "View Ticket",
      };
    });
  }
);
export const currentEventOfOrganiserAction = createAsyncThunk(
  "organiser/current-event",
  async (id) => {
    let res;
    if (id) {
      res = await organiserService.listOfCurrentEventByOrganiser(id);
    } else {
      res = await organiserService.listOfCurrentEventByOrganiser();
    }

    return res.data.map((item) => {
      const sumTotalTickets = Array.isArray(item?.tickets)
        ? item?.tickets?.reduce((acc, ticket) => acc + ticket.totaltickets, 0)
        : 0;

      const sumTicketssold = Array.isArray(item?.tickets)
        ? item?.tickets?.reduce((acc, ticket) => acc + ticket.ticketssold, 0)
        : 0;
      const ticketPrices = Array.isArray(item?.tickets)
        ? item?.tickets?.map((ticket) => ticket.ticketprice)
        : [0];
      return {
        _id: item._id,
        image: item?.image ? item?.image : "",
        category: item.category,
        title: item.title,
        location: item.location,
        startdatetime: item.startdatetime,
        enddatetime: item.enddatetime,
        artist: item.artistsDetails.map((artist) => ({
          id: artist._id,
          artistimage: artist?.image ? artist?.image : "",
          artistname: artist.name,
        })),
        eventstatus: item.eventstatus,
        // isdelivery: item.isdelivery,
        // ticketId: item?.ticketid ? item?.ticketid : "-",
        ticketssold: sumTicketssold,
        totaltickets: sumTotalTickets,
        bookingtiming: item.orderstatustimestamp,
        ticketPrice: item?.ticketprice
          ? item?.ticketprice
          : `${Math.min(...ticketPrices)} - ${Math.max(...ticketPrices)}`,
        viewTicker: "View Ticket",
      };
    });
  }
);
const organiserSlice = createSlice({
  name: "organiser",
  initialState: {
    organiserListAPIResponse: [],
    organiserListAPIError: "",
    createOrganiserAPIResponse: [],
    createOrganiserAPIError: "",
    deleteOrganiserAPIResponse: [],
    deleteOrganiserAPIError: "",
    activeInactiveOrganiserAPIResponse: [],
    activeInactiveOrganiserAPIError: "",
    resendInviteOrganiserAPIResponse: [],
    resendInviteOrganiserAPIError: "",

    currentEventsOfOrganiser: [],
    currentEventsOfOrganiserError: "",
    pastEventsOfOrganiser: [],
    pastEventsOfOrganiserError: "",
    setOrganiserPasswordResponse: [],
    setOrganiserPasswordError: "",
    deleteOrganiserItSelf: [],
    deleteOrganiserItSelfError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(organiserListResponse.pending, (state) => {
        state.loading = true;
      })
      .addCase(organiserListResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.organiserListAPIResponse = action.payload;
      })
      .addCase(organiserListResponse.rejected, (state, action) => {
        state.loading = false;
        state.organiserListAPIError = action?.error;
      });

    // create

    builder
      .addCase(createOrganiserResponse.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrganiserResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.createOrganiserAPIResponse = action.payload;
      })
      .addCase(createOrganiserResponse.rejected, (state, action) => {
        state.loading = false;
        state.createOrganiserAPIError = action?.error;
      });

    // delete
    builder
      .addCase(deleteOrganiserAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteOrganiserAction.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteOrganiserAPIResponse = action.payload;
        state.organiserListAPIResponse = state.organiserListAPIResponse?.filter(
          (item) => item?._id !== action?.payload?.data?._id
        );
      })
      .addCase(deleteOrganiserAction.rejected, (state, action) => {
        state.loading = false;
        state.deleteOrganiserAPIError = action?.error;
      });

    // enbale-disbled
    builder
      .addCase(activeInactiveOrganiserAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(activeInactiveOrganiserAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activeInactiveOrganiserAPIResponse = action.payload?.res;
        state.organiserListAPIResponse = state.organiserListAPIResponse.map(
          (item) => {
            if (item._id === action.payload?.params?._id) {
              return { ...item, status: action.payload?.params?.status };
            }
            return item;
          }
        );
      })
      .addCase(activeInactiveOrganiserAction.rejected, (state, action) => {
        state.isLoading = false;
        state.activeInactiveOrganiserAPIError = action?.error;
      });

    builder
      .addCase(resendInviteOrganiserResponse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendInviteOrganiserResponse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resendInviteOrganiserAPIResponse = action.payload?.res;
      })
      .addCase(resendInviteOrganiserResponse.rejected, (state, action) => {
        state.isLoading = false;
        state.resendInviteOrganiserAPIError = action?.error;
      });

    //current events
    builder
      .addCase(currentEventOfOrganiserAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(currentEventOfOrganiserAction.fulfilled, (state, action) => {
        state.isLoading = false;

        state.currentEventsOfOrganiser = action.payload;
      })
      .addCase(currentEventOfOrganiserAction.rejected, (state, action) => {
        state.isLoading = false;
        state.currentEventsOfOrganiserError = action?.error;
      });

    //past events
    builder
      .addCase(pastEventOfOrganiserAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(pastEventOfOrganiserAction.fulfilled, (state, action) => {
        state.isLoading = false;

        state.pastEventsOfOrganiser = action.payload;
      })
      .addCase(pastEventOfOrganiserAction.rejected, (state, action) => {
        state.isLoading = false;
        state.pastEventsOfOrganiserError = action?.error;
      });
    builder
      .addCase(setOrganiserPasswordAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(setOrganiserPasswordAction.fulfilled, (state, action) => {
        state.isLoading = false;

        state.setOrganiserPasswordResponse = action.payload;
      })
      .addCase(setOrganiserPasswordAction.rejected, (state, action) => {
        state.isLoading = false;
        state.setOrganiserPasswordError = action?.error;
      });
    builder
      .addCase(deleteOrganiserItSelfAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOrganiserItSelfAction.fulfilled, (state, action) => {
        state.isLoading = false;

        state.deleteOrganiserItSelf = action.payload;
      })
      .addCase(deleteOrganiserItSelfAction.rejected, (state, action) => {
        state.isLoading = false;
        state.deleteOrganiserItSelfError = action?.error;
      });
  },
});

export default organiserSlice.reducer;
